import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { NGXLogger } from 'ngx-logger';
import { environment } from 'env';

@Injectable({
    providedIn: 'root'
})
export class NearestAirportService {

    private readonly _nearestAirportEndPoint = environment.airport.nearestAirportEndPoint;

    constructor(private _http: HttpClient,
                private _logger: NGXLogger) {
    }

    searchForNearestAirport(pos): Observable<any> {
        const self = this;
        const options = {
            params: {
                'latitude': pos.coords.latitude,
                'longitude': pos.coords.longitude
            }
        };

        return this._http.get<any>(this._nearestAirportEndPoint, options).pipe(catchError(handleError))

        function handleError(error: HttpErrorResponse) {
            if (error.error instanceof ErrorEvent) {
                // A client-side or network error occurred. Handle it accordingly.
                self._logger.error('Error occurred:', error.error.message);
            } else {
                // The backend returned an unsuccessful response code.
                // The response body may contain clues as to what went wrong.
                self._logger.error(
                    `Backend returned code ${error.status}, ` +
                    `body was: ${error.error}`);
            }
            return throwError(
                'Something went wrong with the http call.');
        }
    }
}
